import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a70b216a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70b216a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a70b216a')) {
      api.createRecord('a70b216a', component.options)
    } else {
      api.reload('a70b216a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a70b216a&scoped=true&", function () {
      api.rerender('a70b216a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/custom/index.vue"
export default component.exports